import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IndicatorValidationHelper } from 'app/shared/objects/cities';
import { SolutionFilterHelper } from 'app/shared/services/forms.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LanguageService } from 'app/shared/services/language.service';

@Component({
  selector: 'app-indicators-benchmark-table',
  templateUrl: './indicators-benchmark-table.component.html',
  styleUrls: ['./indicators-benchmark-table.component.scss']
})
export class IndicatorsBenchmarkTableComponent implements OnInit {
  sdgOpen: {
    ind: string;
    sdg: string;
  };

  @Input() indicatorsData: CityIndicatorsBenchmarking = null;
  @Output() myEvent = new EventEmitter<string>();
  @Input() hideGlobalGoal = false;
  @Input() cityName: string;
  @Input() populationRange: string;
  @Input() subAreas: any[];
  @Input() reportData: any[];
  // Hides the column-label row; the PDF capture renders the header once per
  // area and then one headerless table per sub-area so blocks can flow across
  // pages at full scale.
  @Input() hideHeader = false;
  constructor(
    public router: Router,
    public actived: ActivatedRoute,
    public language: LanguageService,
  ) { }

  ngOnInit() {
    this.sdgOpen = {
      ind: '',
      sdg: ''
    }
  }

  public toggleSubArea(area) {
    area.show = !area.show;
  }


  public hasIndicatorsData() {
    return (this.indicatorsData !== undefined && this.indicatorsData != null) || (this.reportData !== undefined && this.reportData != null);
  }

  public redirIndicator(id) {
    let filter = new SolutionFilterHelper();
    filter.indicatorId = id;
    const params = filter.toParamMap();
    this.router.navigate(['/smart-cities-solutions'], {
        queryParams: params
    });
    return false;
  }

  public toggleSdg(ind, sdg) {
    if (this.sdgOpen.ind == ind.id && this.sdgOpen.sdg == sdg.id) {
      this.sdgOpen.ind = '';
      this.sdgOpen.sdg = '';
    } else {
      this.sdgOpen.ind = ind.id;
      this.sdgOpen.sdg = sdg.id;
    }
  }

  getRange(range): string {
    switch (range) {
      case 'POPULATION_RANGE_1':
        return 'range1';
      case 'POPULATION_RANGE_2':
        return 'range2';
      case 'POPULATION_RANGE_3':
        return 'range3';
      case 'POPULATION_RANGE_4':
        return 'range4';
      case 'POPULATION_RANGE_5':
        return 'range5';
    }
  }

}


export class CityIndicatorsBenchmarking {
  indicators: CityIndicatorBenchmarkingItem[];
}

export class CityIndicatorBenchmarkingItem {
  indicator: CityIndicatorBenchmarkingValue;
  globalGoal: CityIndicatorBenchmarkingValue;
  globalBenchmark: CityIndicatorBenchmarkingValue;
  regionalBenchmark: CityIndicatorBenchmarkingValue;
  populationalBenchmark: CityIndicatorBenchmarkingValue;
}

export class CityIndicatorBenchmarkingValue {
  cityId: string;
  cityName: string;
  description: string;
  flag: string;
  indicatorId: string;
  indicatorUrl: string;
  name: string;
  normalizedScore: number;
  region: string;
  score: number;
  subArea: string;
  sustainableDevelopmentGoals: SustainableDevelopmentGoal[];
  unity: string;
  validation: string;
  alertEnabled: boolean;
}

export class SustainableDevelopmentGoal {
  color: string;
  description: string;
  iconUrl: string;
  id: string;
  name: string;
  number: number;
}
